import styles from './CardGridModuleCarousel.module.scss';

import React from 'react';
import Slider from 'react-slick';

import { Grid } from 'components/Grid/Grid';
import type { AppType } from 'services/cms/typesUtil';
import { SingleCard } from '../SingleCard/SingleCard';

type CardGridModuleCarouselProps = AppType.Component<{
  items: AppType.Content[];
  theme?: string;
}>;

export const CardGridModuleCarousel: React.FC<CardGridModuleCarouselProps> = ({ items, theme, ...props }) => {
  const config = {
    arrows: true,
    infinite: false,
    swipe: true,
    variableWidth: true,
    accessibility: true,
    dots: true,
    cssEase: 'ease',
    dotsClass: styles.cardPaginationDots,
  };

  return (
    <Grid container justifyContent="flex-end" {...props}>
      <Grid item lg={11} md={9} xs={12} className={styles.carouselContainer}>
        <Slider {...config} className={styles.cardSlider}>
          {items?.map(
            item =>
              item && (
                <div key={item._sys?.id} className={styles.carouselContainerCard}>
                  <SingleCard item={item} theme={theme} />
                </div>
              ),
          )}
        </Slider>
      </Grid>
    </Grid>
  );
};
